module.exports = __webpack_public_path__ + "static/media/empty-state-hours.f1258fa5.svg";